// extracted by mini-css-extract-plugin
export default {"walletContainer":"Wallet_walletContainer__YixHa","addToCreditBtn":"Wallet_addToCreditBtn__2aNFH","content":"Wallet_content__FHszw"};